export const companyConfig = {
  name: '巴菲巴健康广告系统',
  shortName: 'dys',
  recordCode: '粤ICP备2025487394号-1',
  address: '安徽省安庆市迎江区经济开发区管委会\n' +
      '环城南路4号普洛斯管理物流园A2号F1\n' +
      '西单元-A(办公室）',
  email: '',
  phone: '020-XXXXXXXX',
  slogan: '健康生活，从心开始',
  description: '专注于健康管理和减肥科技的领先企业',
  foundYear: '2020',
  // wechatQRCode: 'https://mp.weixin.qq.com/mp/qrcode?scene=10000004&size=102&__biz=MzkwOTIyMTIzNg==&mid=2247488605&idx=1&sn=b0faddb57f305d99b39330f6b7472aac&send_time=',
  record_code: '粤ICP备20058473号-1',
  medical_record_code: '粤ICP备20058473号-1',
  socialMedia: {
    weibo: 'https://weibo.com/',
    toutiao: 'https://www.toutiao.com/'
  },
  theme: {
    primary: '#00335b',  // 更深更饱和的蓝色，进一步增强对比度
    secondary: '#0288d1',
    accent: '#e1f5fe',
    footer: '#14679f'
  }
};
